export enum AppletSegmentTypeEnum {
  VEHICLES = 'VEHICLES',
  AGRICULTURAL_MACHINERY = 'AGRICULTURAL_MACHINERY',
}
